import { SVGProps, Ref, forwardRef } from 'react';

export const CheckmarkOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m14 4.849-7.818 7.818L2 8.485l.849-.849 3.333 3.334L13.152 4z"
                fill="currentColor"
            />
        </g>
    </svg>
));
CheckmarkOutlinedSize16Glyph.displayName = 'CheckmarkOutlinedSize16Glyph';
